import { useTranslation } from 'react-i18next'
import { FCC } from '~/core/@types/global'
import { cn } from '~/core/ui/utils'
import SectionContainer from '../LandingPage/components/section/SectionContainer'
import LPContainer from './LPContainer'
import { TypographyText } from '~/core/ui/Text'

const ICON_1 = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="29"
    height="28"
    viewBox="0 0 29 28"
    fill="none">
    <ellipse cx="10.5" cy="9.5" rx="4" ry="5" fill="#D4DAE0" />
    <path
      d="M4.5 18.5L12.5 16.5L19.5 18.5L21 20.5H6.5L3 22.5L4.5 18.5Z"
      fill="#D4DAE0"
    />
    <path
      d="M15.5996 16.6475L15.5996 15.8975H15.5996V16.6475ZM19.7266 18.3564L20.2694 17.8389C20.2652 17.8346 20.2611 17.8303 20.2568 17.8261L19.7266 18.3564ZM19.9268 18.5664L20.4827 18.063C20.4784 18.0582 20.474 18.0535 20.4696 18.0489L19.9268 18.5664ZM21.4365 22.4844H22.1865V22.4844L21.4365 22.4844ZM21.3359 24.8789L21.3312 25.6289H21.3359V24.8789ZM21.2363 22.4844H21.9863V22.4844L21.2363 22.4844ZM19.7783 18.7002L20.3343 18.1968C20.3297 18.1917 20.325 18.1867 20.3203 18.1818L19.7783 18.7002ZM19.585 18.498L20.1269 17.9796C20.1231 17.9756 20.1192 17.9716 20.1152 17.9677L19.585 18.498ZM15.5996 16.8467L15.5996 16.0967H15.5996V16.8467ZM8.71582 16.8467V16.0967H8.7158L8.71582 16.8467ZM4.93164 18.3057L4.42819 17.7498C4.4236 17.7539 4.41907 17.7581 4.4146 17.7624L4.93164 18.3057ZM4.72949 18.498L4.21245 17.9548C4.20796 17.959 4.20354 17.9633 4.19916 17.9677L4.72949 18.498ZM3.07812 22.4844L2.32812 22.4844V22.4844H3.07812ZM2.97852 24.8789L2.97724 25.6289H2.97852V24.8789ZM2.87891 22.4844L2.12891 22.4844V22.4844H2.87891ZM4.58789 18.3564L4.07166 17.8124C4.0669 17.8169 4.0622 17.8215 4.05756 17.8261L4.58789 18.3564ZM4.79785 18.1572L4.29444 17.6013C4.29012 17.6052 4.28585 17.6092 4.28162 17.6132L4.79785 18.1572ZM8.71582 16.6475V15.8975H8.7158L8.71582 16.6475ZM22.127 16.2676L22.3302 15.5456C22.2758 15.5303 22.2199 15.5212 22.1635 15.5185L22.127 16.2676ZM22.3594 16.333L22.5768 15.6152C22.5721 15.6138 22.5674 15.6124 22.5626 15.6111L22.3594 16.333ZM25.2803 18.3428L25.8821 17.8952C25.8791 17.8912 25.8761 17.8872 25.873 17.8832L25.2803 18.3428ZM25.4248 18.5371L26.0361 18.1026C26.033 18.0982 26.0298 18.0938 26.0266 18.0895L25.4248 18.5371ZM26.5039 21.915H27.2539V21.9144L26.5039 21.915ZM26.5039 24.21H25.7539H26.5039ZM26.4043 24.3105V25.0605L26.4056 25.0605L26.4043 24.3105ZM26.3037 24.21H25.5537H26.3037ZM26.3037 21.915H27.0537V21.9144L26.3037 21.915ZM25.2617 18.6533L25.873 18.2188C25.8698 18.2143 25.8665 18.2098 25.8632 18.2053L25.2617 18.6533ZM25.1221 18.4658L25.7236 18.0178C25.7207 18.014 25.7178 18.0101 25.7148 18.0063L25.1221 18.4658ZM22.3018 16.5244L22.5192 15.8066C22.5145 15.8052 22.5097 15.8038 22.5049 15.8025L22.3018 16.5244ZM22.0762 16.4609L21.7408 17.1318C21.7831 17.1529 21.8274 17.1701 21.873 17.1829L22.0762 16.4609ZM22.041 16.4434L21.5835 17.0377C21.6217 17.067 21.6625 17.0926 21.7056 17.1142L22.041 16.4434ZM22.0049 16.3389L21.2803 16.1451L21.2787 16.1514L22.0049 16.3389ZM22.0869 16.2656L22.1235 15.5165C22.0743 15.5141 22.0251 15.5166 21.9764 15.5238L22.0869 16.2656ZM19.2578 3.83789L19.4567 3.11474C19.404 3.10024 19.3499 3.09156 19.2953 3.08883L19.2578 3.83789ZM19.4922 3.90234L19.7083 3.18415C19.7026 3.18243 19.6968 3.18077 19.6911 3.17919L19.4922 3.90234ZM22.4209 5.91309L23.0214 5.4635L23.0133 5.45317L22.4209 5.91309ZM22.5664 6.10742L23.1775 5.67254C23.174 5.66762 23.1704 5.66274 23.1668 5.6579L22.5664 6.10742ZM23.6475 9.49219L24.3975 9.49219V9.49215L23.6475 9.49219ZM22.5664 12.876L23.1678 13.324C23.1711 13.3196 23.1744 13.3152 23.1775 13.3107L22.5664 12.876ZM22.4209 13.0713L23.0133 13.5312C23.0164 13.5273 23.0194 13.5233 23.0223 13.5194L22.4209 13.0713ZM19.4922 15.0811L19.6939 15.8034C19.6987 15.8021 19.7035 15.8007 19.7083 15.7992L19.4922 15.0811ZM19.2578 15.1465L19.4413 15.8737C19.4474 15.8722 19.4534 15.8705 19.4595 15.8689L19.2578 15.1465ZM19.1367 15.0742L18.4093 15.2569L18.4102 15.2602L19.1367 15.0742ZM19.209 14.9531L19.395 15.6797C19.4007 15.6782 19.4064 15.6767 19.4121 15.6751L19.209 14.9531ZM19.4346 14.8896L19.6378 15.6117L19.6507 15.6078L19.4346 14.8896ZM22.2637 12.9482L22.8561 13.4081C22.8592 13.4042 22.8622 13.4002 22.8652 13.3962L22.2637 12.9482ZM22.4033 12.7607L23.0048 13.2087C23.0081 13.2044 23.0113 13.2 23.0144 13.1956L22.4033 12.7607ZM23.4473 9.49219L24.1973 9.49219V9.49214L23.4473 9.49219ZM22.4033 6.22363L23.0144 5.78876C23.0112 5.78435 23.0081 5.77998 23.0048 5.77564L22.4033 6.22363ZM22.2637 6.03613L22.8652 5.58814C22.8622 5.58415 22.8592 5.58018 22.8561 5.57625L22.2637 6.03613ZM19.4346 4.09473L19.6507 3.37643L19.6377 3.37276L19.4346 4.09473ZM19.209 4.03125L18.8959 4.71276C18.9314 4.72909 18.9682 4.74262 19.0058 4.75321L19.209 4.03125ZM19.1729 4.01465L18.7203 4.6127C18.7636 4.64549 18.8104 4.67347 18.8597 4.69616L19.1729 4.01465ZM19.1367 3.91016L18.4109 3.72129L18.4096 3.72648L19.1367 3.91016ZM19.2188 3.83594L19.2562 3.08687C19.2068 3.0844 19.1572 3.08683 19.1083 3.09412L19.2188 3.83594ZM12.1582 2.87891L12.1583 2.12891H12.1582V2.87891ZM17.9941 8.71582L18.7441 8.71588V8.71579L17.9941 8.71582ZM12.1582 14.5518V15.3018H12.1583L12.1582 14.5518ZM6.32129 8.71582L5.57129 8.71579V8.71588L6.32129 8.71582ZM12.1582 3.07812L12.1583 2.32812H12.1582V3.07812ZM6.52051 8.71582L5.77051 8.71579V8.71588L6.52051 8.71582ZM12.1582 14.3525V15.1025H12.1583L12.1582 14.3525ZM17.7949 8.71582L18.5449 8.71588V8.71579L17.7949 8.71582ZM15.5996 16.6475L15.5996 17.3975C16.9486 17.3975 18.2424 17.9331 19.1963 18.8868L19.7266 18.3564L20.2568 17.8261C19.0216 16.591 17.3463 15.8975 15.5996 15.8975L15.5996 16.6475ZM19.7266 18.3564L19.1838 18.874L19.384 19.084L19.9268 18.5664L20.4696 18.0489L20.2694 17.8389L19.7266 18.3564ZM19.9268 18.5664L19.3708 19.0698C20.2155 20.0028 20.6865 21.2196 20.6865 22.4844L21.4365 22.4844L22.1865 22.4844C22.1865 20.8469 21.5768 19.2714 20.4827 18.063L19.9268 18.5664ZM21.4365 22.4844H20.6865V24.7783H21.4365H22.1865V22.4844H21.4365ZM21.4365 24.7783H20.6865C20.6865 24.4193 20.977 24.1289 21.3359 24.1289V24.8789V25.6289C21.8054 25.6289 22.1865 25.2478 22.1865 24.7783H21.4365ZM21.3359 24.8789L21.3407 24.1289C21.701 24.1312 21.9863 24.4239 21.9863 24.7783H21.2363H20.4863C20.4863 25.2428 20.861 25.6259 21.3312 25.6289L21.3359 24.8789ZM21.2363 24.7783H21.9863V22.4844H21.2363H20.4863V24.7783H21.2363ZM21.2363 22.4844L21.9863 22.4844C21.9863 20.8966 21.3954 19.3686 20.3343 18.1968L19.7783 18.7002L19.2224 19.2036C20.0339 20.0998 20.4863 21.2691 20.4863 22.4844L21.2363 22.4844ZM19.7783 18.7002L20.3203 18.1818L20.1269 17.9796L19.585 18.498L19.043 19.0165L19.2363 19.2186L19.7783 18.7002ZM19.585 18.498L20.1152 17.9677C18.9177 16.7704 17.2936 16.0967 15.5996 16.0967L15.5996 16.8467L15.5996 17.5967C16.8952 17.5967 18.1381 18.112 19.0547 19.0284L19.585 18.498ZM15.5996 16.8467V16.0967H8.71582V16.8467V17.5967H15.5996V16.8467ZM8.71582 16.8467L8.7158 16.0967C7.12758 16.0967 5.59979 16.6887 4.42819 17.7498L4.93164 18.3057L5.4351 18.8616C6.33156 18.0497 7.50073 17.5967 8.71584 17.5967L8.71582 16.8467ZM4.93164 18.3057L4.4146 17.7624L4.21245 17.9548L4.72949 18.498L5.24654 19.0413L5.44869 18.849L4.93164 18.3057ZM4.72949 18.498L4.19916 17.9677C3.00147 19.1654 2.32817 20.7905 2.32812 22.4844L3.07812 22.4844L3.82812 22.4844C3.82816 21.1884 4.34337 19.9448 5.25982 19.0284L4.72949 18.498ZM3.07812 22.4844H2.32812V24.7783H3.07812H3.82812V22.4844H3.07812ZM3.07812 24.7783H2.32812C2.32812 24.4289 2.61004 24.1289 2.97852 24.1289V24.8789V25.6289C3.45745 25.6289 3.82812 25.2382 3.82812 24.7783H3.07812ZM2.97852 24.8789L2.97979 24.1289C3.34609 24.1295 3.62891 24.4276 3.62891 24.7783H2.87891H2.12891C2.12891 25.2394 2.50065 25.6281 2.97724 25.6289L2.97852 24.8789ZM2.87891 24.7783H3.62891V22.4844H2.87891H2.12891V24.7783H2.87891ZM2.87891 22.4844L3.62891 22.4844C3.62894 21.135 4.1645 19.8405 5.11822 18.8868L4.58789 18.3564L4.05756 17.8261C2.82212 19.0616 2.12895 20.7378 2.12891 22.4844L2.87891 22.4844ZM4.58789 18.3564L5.10412 18.9005L5.31408 18.7013L4.79785 18.1572L4.28162 17.6132L4.07166 17.8124L4.58789 18.3564ZM4.79785 18.1572L5.30126 18.7132C6.23422 17.8684 7.45091 17.3975 8.71584 17.3975L8.71582 16.6475L8.7158 15.8975C7.07824 15.8975 5.50285 16.5071 4.29444 17.6013L4.79785 18.1572ZM8.71582 16.6475V17.3975H15.5996V16.6475V15.8975H8.71582V16.6475ZM22.127 16.2676L21.9237 16.9895L22.1561 17.0549L22.3594 16.333L22.5626 15.6111L22.3302 15.5456L22.127 16.2676ZM22.3594 16.333L22.142 17.0508C23.1499 17.3561 24.0402 17.9674 24.6876 18.8023L25.2803 18.3428L25.873 17.8832C25.0347 16.802 23.8818 16.0105 22.5768 15.6152L22.3594 16.333ZM25.2803 18.3428L24.6785 18.7904L24.823 18.9847L25.4248 18.5371L26.0266 18.0895L25.8821 17.8952L25.2803 18.3428ZM25.4248 18.5371L24.8135 18.9717C25.4235 19.8297 25.753 20.8589 25.7539 21.9157L26.5039 21.915L27.2539 21.9144C27.2528 20.5466 26.8263 19.2142 26.0361 18.1026L25.4248 18.5371ZM26.5039 21.915H25.7539V24.21H26.5039H27.2539V21.915H26.5039ZM26.5039 24.21H25.7539C25.7539 23.8592 26.0367 23.5612 26.403 23.5605L26.4043 24.3105L26.4056 25.0605C26.8822 25.0597 27.2539 24.6711 27.2539 24.21H26.5039ZM26.4043 24.3105V23.5605C26.7633 23.5605 27.0537 23.851 27.0537 24.21H26.3037H25.5537C25.5537 24.6794 25.9349 25.0605 26.4043 25.0605V24.3105ZM26.3037 24.21H27.0537V21.915H26.3037H25.5537V24.21H26.3037ZM26.3037 21.915L27.0537 21.9144C27.0526 20.5882 26.6391 19.2966 25.873 18.2188L25.2617 18.6533L24.6504 19.0878C25.2363 19.9121 25.5529 20.9005 25.5537 21.9157L26.3037 21.915ZM25.2617 18.6533L25.8632 18.2053L25.7236 18.0178L25.1221 18.4658L24.5206 18.9138L24.6602 19.1013L25.2617 18.6533ZM25.1221 18.4658L25.7148 18.0063C24.9022 16.9581 23.7848 16.19 22.5192 15.8066L22.3018 16.5244L22.0843 17.2422C23.0523 17.5354 23.9074 18.1231 24.5293 18.9254L25.1221 18.4658ZM22.3018 16.5244L22.5049 15.8025L22.2793 15.739L22.0762 16.4609L21.873 17.1829L22.0986 17.2464L22.3018 16.5244ZM22.0762 16.4609L22.4116 15.7901L22.3764 15.7725L22.041 16.4434L21.7056 17.1142L21.7408 17.1318L22.0762 16.4609ZM22.041 16.4434L22.4985 15.8491C22.6948 16.0002 22.7993 16.2622 22.7311 16.5264L22.0049 16.3389L21.2787 16.1514C21.1898 16.4955 21.3257 16.8392 21.5835 17.0377L22.041 16.4434ZM22.0049 16.3389L22.7294 16.5327C22.6603 16.7911 22.4451 16.9705 22.1974 17.0074L22.0869 16.2656L21.9764 15.5238C21.6523 15.5721 21.3707 15.8074 21.2804 16.1451L22.0049 16.3389ZM22.0869 16.2656L22.0504 17.0147L22.0904 17.0167L22.127 16.2676L22.1635 15.5185L22.1235 15.5165L22.0869 16.2656ZM19.2578 3.83789L19.0589 4.56104L19.2933 4.6255L19.4922 3.90234L19.6911 3.17919L19.4567 3.11474L19.2578 3.83789ZM19.4922 3.90234L19.2761 4.62054C20.2863 4.92449 21.1791 5.53651 21.8285 6.373L22.4209 5.91309L23.0133 5.45317C22.1729 4.3705 21.017 3.57791 19.7083 3.18415L19.4922 3.90234ZM22.4209 5.91309L21.8205 6.3626L21.966 6.55694L22.5664 6.10742L23.1668 5.6579L23.0213 5.46357L22.4209 5.91309ZM22.5664 6.10742L21.9554 6.5423C22.5672 7.40193 22.8974 8.4332 22.8975 9.49223L23.6475 9.49219L24.3975 9.49215C24.3974 8.12131 23.97 6.78608 23.1775 5.67254L22.5664 6.10742ZM23.6475 9.49219L22.8975 9.49218C22.8975 10.5506 22.5669 11.5814 21.9553 12.4412L22.5664 12.876L23.1775 13.3107C23.9694 12.1976 24.3974 10.863 24.3975 9.49219L23.6475 9.49219ZM22.5664 12.876L21.965 12.4279L21.8195 12.6232L22.4209 13.0713L23.0223 13.5194L23.1678 13.324L22.5664 12.876ZM22.4209 13.0713L21.8285 12.6114C21.1794 13.4474 20.2865 14.0588 19.276 14.3629L19.4922 15.0811L19.7083 15.7992C21.0164 15.4055 22.1727 14.6141 23.0133 13.5312L22.4209 13.0713ZM19.4922 15.0811L19.2905 14.3587L19.0561 14.4241L19.2578 15.1465L19.4595 15.8689L19.6939 15.8034L19.4922 15.0811ZM19.2578 15.1465L19.0743 14.4193C19.4243 14.331 19.7752 14.544 19.8633 14.8882L19.1367 15.0742L18.4102 15.2602C18.5256 15.7112 18.9845 15.989 19.4413 15.8737L19.2578 15.1465ZM19.1367 15.0742L19.8641 14.8915C19.9517 15.2402 19.74 15.5913 19.395 15.6797L19.209 14.9531L19.023 14.2266C18.5712 14.3422 18.2949 14.8015 18.4093 15.2569L19.1367 15.0742ZM19.209 14.9531L19.4121 15.6751L19.6377 15.6116L19.4346 14.8896L19.2314 14.1677L19.0058 14.2312L19.209 14.9531ZM19.4346 14.8896L19.6507 15.6078C20.9192 15.2261 22.041 14.4583 22.8561 13.4081L22.2637 12.9482L21.6712 12.4884C21.0477 13.2916 20.1893 13.8793 19.2184 14.1715L19.4346 14.8896ZM22.2637 12.9482L22.8652 13.3962L23.0048 13.2087L22.4033 12.7607L21.8018 12.3127L21.6622 12.5002L22.2637 12.9482ZM22.4033 12.7607L23.0144 13.1956C23.7826 12.1159 24.1973 10.8214 24.1973 9.49219L23.4473 9.49219L22.6973 9.49218C22.6973 10.5094 22.3799 11.5 21.7922 12.3259L22.4033 12.7607ZM23.4473 9.49219L24.1973 9.49214C24.1972 8.16297 23.7828 6.86846 23.0144 5.78876L22.4033 6.22363L21.7923 6.6585C22.38 7.48432 22.6972 8.47488 22.6973 9.49223L23.4473 9.49219ZM22.4033 6.22363L23.0048 5.77564L22.8652 5.58814L22.2637 6.03613L21.6622 6.48413L21.8018 6.67163L22.4033 6.22363ZM22.2637 6.03613L22.8561 5.57625C22.041 4.52609 20.9192 3.75829 19.6507 3.37654L19.4346 4.09473L19.2184 4.81291C20.1893 5.10507 21.0477 5.69272 21.6712 6.49602L22.2637 6.03613ZM19.4346 4.09473L19.6377 3.37276L19.4121 3.30929L19.209 4.03125L19.0058 4.75321L19.2314 4.81669L19.4346 4.09473ZM19.209 4.03125L19.5221 3.34974L19.486 3.33314L19.1729 4.01465L18.8597 4.69616L18.8959 4.71276L19.209 4.03125ZM19.1729 4.01465L19.6254 3.41659C19.833 3.57365 19.928 3.83995 19.8639 4.09384L19.1367 3.91016L18.4096 3.72648C18.3252 4.06062 18.4506 4.40861 18.7203 4.6127L19.1729 4.01465ZM19.1367 3.91016L19.8625 4.09902C19.7961 4.35437 19.5837 4.53984 19.3292 4.57775L19.2188 3.83594L19.1083 3.09412C18.7768 3.14349 18.4981 3.38599 18.4109 3.72129L19.1367 3.91016ZM19.2188 3.83594L19.1813 4.585L19.2204 4.58695L19.2578 3.83789L19.2953 3.08883L19.2562 3.08687L19.2188 3.83594ZM12.1582 2.87891L12.1581 3.62891C14.9671 3.62918 17.244 5.90662 17.2441 8.71585L17.9941 8.71582L18.7441 8.71579C18.744 5.07843 15.7958 2.12926 12.1583 2.12891L12.1582 2.87891ZM17.9941 8.71582L17.2441 8.71576C17.2439 11.5248 14.9672 13.8015 12.1581 13.8018L12.1582 14.5518L12.1583 15.3018C15.7956 15.3014 18.7439 12.3533 18.7441 8.71588L17.9941 8.71582ZM12.1582 14.5518V13.8018C9.34887 13.8018 7.07151 11.5249 7.07129 8.71576L6.32129 8.71582L5.57129 8.71588C5.57157 12.3535 8.52065 15.3018 12.1582 15.3018V14.5518ZM6.32129 8.71582L7.07129 8.71585C7.0714 5.90652 9.34893 3.62891 12.1582 3.62891V2.87891V2.12891C8.52044 2.12891 5.57144 5.07814 5.57129 8.71579L6.32129 8.71582ZM12.1582 3.07812V2.32812C8.6309 2.32812 5.77066 5.1886 5.77051 8.71579L6.52051 8.71582L7.27051 8.71585C7.27062 6.01698 9.45939 3.82812 12.1582 3.82812V3.07812ZM6.52051 8.71582L5.77051 8.71588C5.77079 12.2431 8.63111 15.1025 12.1582 15.1025V14.3525V13.6025C9.45932 13.6025 7.27072 11.4144 7.27051 8.71576L6.52051 8.71582ZM12.1582 14.3525L12.1583 15.1025C15.6851 15.1022 18.5446 12.2428 18.5449 8.71588L17.7949 8.71582L17.0449 8.71576C17.0447 11.4143 14.8567 13.6023 12.1581 13.6025L12.1582 14.3525ZM17.7949 8.71582L18.5449 8.71579C18.5448 5.18889 15.6854 2.32848 12.1583 2.32812L12.1582 3.07812L12.1581 3.82812C14.8566 3.8284 17.0448 6.01708 17.0449 8.71585L17.7949 8.71582Z"
      fill="#474C5E"
    />
  </svg>
)

const ICON_2 = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none">
    <path
      d="M3 7.5V15.5L8 17.5L14.5 18L20 17.5L25 15.5V7.5L21.5 9L17 10H10L6.5 9L3 7.5Z"
      fill="#D4DAE0"
    />
    <path
      d="M3 21.5V23.5L8 25.5L14.5 26L20 25.5L25 23.5V18.5L21 21.5C21 21.5 15.5632 23 12 23C8.4368 23 3 21.5 3 21.5Z"
      fill="#D4DAE0"
    />
    <path
      d="M6.64014 2.51973C8.56515 1.87807 11.1548 1.5 13.9649 1.5C16.7751 1.5 19.3647 1.87807 21.2897 2.51973C22.2465 2.83866 23.0998 3.24258 23.7365 3.74436C24.3609 4.23639 24.9298 4.95181 24.9298 5.88596C24.9298 6.82012 24.3609 7.53554 23.7365 8.02757C23.0998 8.52935 22.2465 8.93327 21.2897 9.2522C19.3647 9.89386 16.7751 10.2719 13.9649 10.2719C11.1548 10.2719 8.56515 9.89386 6.64014 9.2522C5.68337 8.93327 4.83 8.52935 4.1933 8.02757C3.56896 7.53554 3 6.82012 3 5.88596C3 4.95181 3.56896 4.23639 4.1933 3.74436C4.83 3.24258 5.68337 2.83866 6.64014 2.51973Z"
      stroke="#474C5E"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M24.9298 13.5613C24.9298 14.4926 24.3671 15.2083 23.7434 15.7025C23.1086 16.2055 22.2575 16.6097 21.3023 16.9286C19.3804 17.5703 16.7903 17.9472 13.9649 17.9472C11.1395 17.9472 8.54944 17.5703 6.62756 16.9286C5.67228 16.6097 4.82117 16.2055 4.18647 15.7025C3.56271 15.2083 3 14.4926 3 13.5613"
      stroke="#474C5E"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M24.9298 6.10534V22.1141C24.9298 23.0455 24.3671 23.7611 23.7434 24.2554C23.1086 24.7583 22.2575 25.1626 21.3023 25.4815C19.3804 26.1231 16.7903 26.5001 13.9649 26.5001C11.1395 26.5001 8.54944 26.1231 6.62756 25.4815C5.67228 25.1626 4.82117 24.7583 4.18647 24.2554C3.56271 23.7611 3 23.0455 3 22.1141V5.66675"
      stroke="#474C5E"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

const ICON_3 = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="29"
    height="28"
    viewBox="0 0 29 28"
    fill="none">
    <path
      d="M2.66675 20.5H22.1667L26.1667 17V22.5L25.1667 26.5H3.66675L2.66675 20.5Z"
      fill="#D4DAE0"
    />
    <path
      d="M2.8335 7C2.8335 5.067 4.4005 3.5 6.3335 3.5H22.6668C24.5998 3.5 26.1668 5.067 26.1668 7V23.3333C26.1668 25.2663 24.5998 26.8333 22.6668 26.8333H6.3335C4.4005 26.8333 2.8335 25.2663 2.8335 23.3333V7Z"
      stroke="#474C5E"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18 6.99992V2.33325"
      stroke="#474C5E"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11 2.33325V6.99992"
      stroke="#474C5E"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.66675 11H25.6667"
      stroke="#474C5E"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

const ICON_4 = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="29"
    height="28"
    viewBox="0 0 29 28"
    fill="none">
    <path d="M9.5 1H19.5L20 4.5L19.5 8H9.5L9 4.5L9.5 1Z" fill="#D4DAE0" />
    <path
      d="M3.5 23.1842H20.9255L24.5 19.5L24.5001 22.7894L23.6065 26.9999H6L3.5 23.1842Z"
      fill="#D4DAE0"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.66675 3.33333C8.66675 2.04467 9.71142 1 11.0001 1H18.0001C19.2887 1 20.3334 2.04467 20.3334 3.33333V5.66667C20.3334 6.95533 19.2887 8 18.0001 8H11.0001C9.71142 8 8.66675 6.95533 8.66675 5.66667V3.33333Z"
      stroke="#474C5E"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.5 3.5H21.5C22.4283 3.5 23.3185 3.86875 23.9749 4.52513C24.6313 5.1815 25 6.07174 25 7V23.3333C25 24.2616 24.6313 25.1518 23.9749 25.8082C23.3185 26.4646 22.4283 26.8333 21.5 26.8333H7.5C6.57174 26.8333 5.6815 26.4646 5.02513 25.8082C4.36875 25.1518 4 24.2616 4 23.3333V7C4 6.07174 4.36875 5.1815 5.02513 4.52513C5.6815 3.86875 6.57174 3.5 7.5 3.5H8.5"
      stroke="#474C5E"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.1667 14H13.5"
      stroke="#474C5E"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.1667 19H13.5"
      stroke="#474C5E"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.5 14C9.5 13.4477 9.94549 13 10.495 13H10.505C11.0545 13 11.5 13.4477 11.5 14C11.5 14.5523 11.0545 15 10.505 15H10.495C9.94549 15 9.5 14.5523 9.5 14Z"
      fill="#474C5E"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.5 19C9.5 18.4477 9.94549 18 10.495 18H10.505C11.0545 18 11.5 18.4477 11.5 19C11.5 19.5523 11.0545 20 10.505 20H10.495C9.94549 20 9.5 19.5523 9.5 19Z"
      fill="#474C5E"
    />
  </svg>
)

const RecruitmentPlacementSection: FCC<{ className?: string }> = ({
  className
}) => {
  const { t, i18n } = useTranslation()

  const SECTIONS = [
    {
      contentTitle: t(
        'solutions:recruitment_placement:section_1_content_title'
      ),
      contentDescription: t(
        'solutions:recruitment_placement:section_1_content_description'
      ),
      contentImage: '/img/feature/lp/new/solutionPlacement01.png',
      direction: 'ltr',
      contentLink: '#'
    },
    {
      contentTitle: t(
        'solutions:recruitment_placement:section_2_content_title'
      ),
      contentDescription: t(
        'solutions:recruitment_placement:section_2_content_description'
      ),
      contentImage: '/img/feature/lp/new/solutionPlacement02.png',
      direction: 'rtl',
      contentBoxShow: true,
      contentBox01: {
        iconType: ICON_1,
        title: t(
          'solutions:recruitment_placement:section_2_content_box_1_title'
        ),
        description: t(
          'solutions:recruitment_placement:section_2_content_box_1_description'
        )
      },
      contentBox02: {
        iconType: ICON_2,
        title: t(
          'solutions:recruitment_placement:section_2_content_box_2_title'
        ),
        description: t(
          'solutions:recruitment_placement:section_2_content_box_2_description'
        )
      },
      contentLink: '#'
    },
    {
      contentTitle: t(
        'solutions:recruitment_placement:section_3_content_title'
      ),
      contentDescription: t(
        'solutions:recruitment_placement:section_3_content_description'
      ),
      contentImage: '/img/feature/lp/new/solutionPlacement03.png',
      direction: 'ltr',
      contentBoxShow: true,
      contentBox01: {
        iconType: ICON_3,
        title: t(
          'solutions:recruitment_placement:section_3_content_box_1_title'
        ),
        description: t(
          'solutions:recruitment_placement:section_3_content_box_1_description'
        )
      },
      contentBox02: {
        iconType: ICON_4,
        title: t(
          'solutions:recruitment_placement:section_3_content_box_2_title'
        ),
        description: t(
          'solutions:recruitment_placement:section_3_content_box_2_description'
        )
      },
      contentLink: '#'
    },
    {
      contentTitle: t(
        'solutions:recruitment_placement:section_4_content_title'
      ),
      contentDescription: t(
        'solutions:recruitment_placement:section_4_content_description'
      ),
      contentImage: '/img/feature/lp/new/solutionPlacement04.png',
      direction: 'rtl',
      contentLink: '#'
    },
    {
      contentTitle: t(
        'solutions:recruitment_placement:section_5_content_title'
      ),
      contentDescription: t(
        'solutions:recruitment_placement:section_5_content_description'
      ),
      contentImage: '/img/feature/lp/new/solutionPlacement05.png',
      direction: 'ltr',
      contentLink: '#'
    },
    {
      contentTitle: t(
        'solutions:recruitment_placement:section_6_content_title'
      ),
      contentDescription: t(
        'solutions:recruitment_placement:section_6_content_description'
      ),
      contentImage: '/img/feature/lp/new/solutionPlacement06.png',
      direction: 'rtl',
      contentLink: '#'
    },
    {
      contentTitle: t(
        'solutions:recruitment_placement:section_7_content_title'
      ),
      contentDescription: t(
        'solutions:recruitment_placement:section_7_content_description'
      ),
      contentImage: '/img/feature/lp/new/solutionPlacement07.png',
      direction: 'ltr',
      contentLink: '#'
    }
  ]

  return (
    <SectionContainer
      title="solutions:recruitment_placement:title"
      // tagLabel="solutions:recruitment_placement:tag"
      // tagColor="bg-green-100 text-green-800"
      className={cn(className, 'pb-5 my-[44px] desktop:my-[140px]')}>
      <LPContainer className="mt-6 space-y-10 px-0 tablet:px-4">
        {SECTIONS.map((item, index) => {
          return (
            <div
              key={index}
              className={cn(
                'items-center flex flex-col tablet:flex-row',
                item.direction === 'ltr' ? '' : 'tablet:flex-row-reverse'
              )}>
              <div
                className={cn(
                  'flex-1 mb-20 tablet:mb-0',
                  item.direction === 'ltr' ? 'tablet:mr-20' : 'tablet:ml-20'
                )}>
                <TypographyText className="text-[23px] leading-[28px] font-medium text-gray-900">
                  {item.contentTitle}
                </TypographyText>
                <TypographyText className="text-base font-normal text-gray-700 mt-3">
                  {item.contentDescription}
                </TypographyText>
                {item.contentBoxShow ? (
                  <div className="mt-6 flex space-x-[22px]">
                    {item.contentBox01 ? (
                      <div className="flex-1">
                        {item.contentBox01.iconType}
                        <TypographyText className="text-lg text-gray-900 font-medium mt-3">
                          {item.contentBox01.title}
                        </TypographyText>
                        <TypographyText className="text-base text-gray-700 font-normal">
                          {item.contentBox01.description}
                        </TypographyText>
                      </div>
                    ) : null}
                    {item.contentBox02 ? (
                      <div className="flex-1">
                        {item.contentBox02.iconType}
                        <TypographyText className="text-lg text-gray-900 font-medium mt-3">
                          {item.contentBox02.title}
                        </TypographyText>
                        <TypographyText className="text-base text-gray-700 font-normal">
                          {item.contentBox02.description}
                        </TypographyText>
                      </div>
                    ) : null}
                  </div>
                ) : null}
              </div>

              <div className="bg-gray-100">
                <img
                  src={item.contentImage}
                  alt={`screenshot ${index}`}
                  className="tablet:max-w-[495px] max-w-full"
                />
              </div>
            </div>
          )
        })}
      </LPContainer>
    </SectionContainer>
  )
}

export default RecruitmentPlacementSection
